import GeneralInfoView from './GeneralInfoView/GeneralInfoView'
import { dateConverter } from '../../../../../utils/dateConverter'
import { useSingleSpendingDemand, useSpendingDemandSpendingList, useSpendingDemandSubCreditList, useSpendingDemandPaymentSummary } from '../../../hooks'
import { numberToStingWithSpaces } from '../../../../../utils/numberDisplayer'
import { spendingDemandStatusRawToReadableStatus } from '../../../utils/spenpdingDemandStatusConverter'
import { useSingleBoxAssociation } from '../../../../boxAssociation/hooks/useBoxAssociation'
import Loader from '../../../../../components/atoms/Loader/Loader'




const UNIT = "FCFA"



export default function GeneralInfoPresenter() {

  const {singleSpendingDemandData:singleSpending, isLoading, managerWaitingValidation } = useSingleSpendingDemand()
  
  const spendingDemandId = singleSpending?.spending_demand_id || ''
  const { totalSpending } = useSpendingDemandSpendingList(spendingDemandId, {
    disableQuery: !spendingDemandId
  })
  const { totalSubCredit } = useSpendingDemandSubCreditList(spendingDemandId, {
    disableQuery: !spendingDemandId
  })
  const { paymentSummary } = useSpendingDemandPaymentSummary(spendingDemandId, {
    disableQuery: !spendingDemandId
  })
  


  const userName = singleSpending?.spending_demand_user?.username
  const userLastName = singleSpending?.spending_demand_user?.lastname
  const projectName = singleSpending?.spending_demand_project?.project_name

  // Récupérer les informations de la box association si le type est BOX
  const boxAssociationId = singleSpending?.spending_demand_box_association_id
  const {
    boxAssociation,
  } = useSingleBoxAssociation(
    singleSpending?.spending_demand_type === "BOX" && boxAssociationId
      ? boxAssociationId
      : undefined,
    { disableQuery: !boxAssociationId || singleSpending?.spending_demand_type !== "BOX" }
  )

  const files = singleSpending?.spending_demand_files

  const urlBackend = process.env.REACT_APP_URL_BACKEND+"/photos/single/"

  const listManagerWaitingValisation = managerWaitingValidation.data



  
  

  const filesformated = files?.map((file, index) => {
    return {
      src: urlBackend+file.filename,
      filename: "fichier"+index+".jpeg",
      filetype: "image/jpeg",
    }
  })

  


  if(isLoading) return <Loader centered paddingTop="20%" />
  if(!singleSpending) return <div>Désolé, Une erreur est survenue</div>

  const colorStatus = spendingDemandStatusRawToReadableStatus(
    singleSpending?.spending_demand_status || "",
    "for-user"
  ).color

  const isValidate = singleSpending?.spending_demand_status === "VALIDATE" || singleSpending?.spending_demand_status === "PAYED" || singleSpending?.spending_demand_status === "CLOSED" || singleSpending?.spending_demand_status === "CREDITED"
  
  const totalSpentTTC = totalSpending?.totalTTC || 0
  const amountTTC = singleSpending?.spending_demand_amountTTC || 0

  const totalSubCreditAmount = totalSubCredit?.totalAmount || 0

  const remainingAmount = amountTTC - totalSpentTTC
  const subCreditBalance = totalSubCreditAmount - totalSpentTTC
  
  const totalSpentFormatted = isValidate && totalSpentTTC > 0 ? numberToStingWithSpaces(totalSpentTTC) + ' ' + UNIT : undefined
  const remainingAmountFormatted = isValidate ? numberToStingWithSpaces(Math.max(0, remainingAmount)) + ' ' + UNIT : undefined

  const totalSubCreditFormatted = totalSubCreditAmount > 0 ? numberToStingWithSpaces(totalSubCreditAmount) + ' ' + UNIT : undefined

  const totalPayedCollabFormatted = paymentSummary.totalPayedCollab > 0 ? numberToStingWithSpaces(paymentSummary.totalPayedCollab) + ' ' + UNIT : undefined
  const totalAcompteFormatted = paymentSummary.totalAcompte > 0 ? numberToStingWithSpaces(paymentSummary.totalAcompte) + ' ' + UNIT : undefined

  const subCreditBalanceFormatted = totalSubCreditAmount > 0 ? numberToStingWithSpaces(subCreditBalance) + ' ' + UNIT : undefined
  const isTotalSpentExceeded = totalSpentTTC > amountTTC
  const isRemainingAmountPositive = remainingAmount > 0
  const isSubCreditBalancePositive = subCreditBalance > 0

  return (<GeneralInfoView
      amount={ numberToStingWithSpaces(amountTTC)+' '+UNIT}
      totalSpent={totalSpentFormatted}
      remainingAmount={remainingAmountFormatted}
     
      totalSubCredit={totalSubCreditFormatted}
      totalPayedCollab={totalPayedCollabFormatted}
      totalAcompte={totalAcompteFormatted}
      subCreditBalance={subCreditBalanceFormatted}
      isTotalSpentExceeded={isTotalSpentExceeded}
      isRemainingAmountPositive={isRemainingAmountPositive}
      isSubCreditBalancePositive={isSubCreditBalancePositive}
      description={singleSpending?.spending_demand_desc}
      paymentDate={singleSpending?.spending_demand_date && dateConverter(singleSpending?.spending_demand_date)}
      updateAtDate={singleSpending?.spending_demand_update_date && dateConverter(singleSpending?.spending_demand_date)}
      userName={userName}
      userLastname={userLastName}
      projectName={projectName}
      spendingDemandType={singleSpending?.spending_demand_type}
      boxAssociationId={boxAssociationId}
      boxId={boxAssociation?.boxId}
      statut={singleSpending ? spendingDemandStatusRawToReadableStatus(singleSpending?.spending_demand_status,"general",singleSpending?.is_to_process ).status : undefined}
      remak={singleSpending?.spending_demand_remarks}
      filesList={filesformated}
      managerWaitingValidation={listManagerWaitingValisation.map((manager) => ({ firstname: manager?.username, lastname: manager?.lastname}))}
      colorStatus={{backgroundColor: colorStatus.light, color: colorStatus.dark}}
      spendingDemandLastTeamFrom={singleSpending?.last_team_from_by_process_by?.[0]?.team_id}
      spendingDemandComptableTeam={singleSpending?.spending_demand_comptable_team}
      spendingDemandReadableId={singleSpending?.spending_demand_readable_id}
    />)
}


